/**
 * Created by EuanSmith on 28/06/2016.
 */

//! use bluebird's Promise globally
// window.Promise = require("bluebird");
// window.Promise.config({
//   warnings: false,
//   longStackTraces: false,
//   cancellation: true,
//   monitoring: false
// });

import router from './router'
// import store from 'src/store'

// require('@lightblue/uibase');

// import 'vue-resize/dist/vue-resize.css'

import Vue from 'vue'
// import VueI18n from 'vue-i18n'
// import VueTouch from 'vue-touch'
// import VueResize from 'vue-resize'
// import MediaQueries from 'vue-media-queries'

// const mediaQueries = new MediaQueries()

// Vue.use(VueI18n)
// Vue.use(VueTouch);
// Vue.use(VueResize);
// Vue.use(mediaQueries)

import App from './App.vue';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n: null,
  router,
  store: null,
  template: '<App/>',
  components: { App },
  // mediaQueries: mediaQueries
})

